<template>
    <div class="content">
        <!-- start banner -->
		<div id="banner-part" class="subbanner">
			<div class="container max-1762">
				<div class="row">
					<div class="col column-left">
					</div>
					<div class="col column-right">
						<div class="overlay">
							<div class="megatitle-sub"><h2>Vacature detail</h2></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- end banner -->
		
		<!-- start content -->
		<div id="content-part">
		
			<!-- start megapanel-bar -->
			<div class="megapanel-bar description-bar">
				<div class="container">
					<div class="row">
						<div class="col-12">
							<div class="inner">
								<div class="top-panel bg-yellow">
									<div class="row mrg0">
										<div class="col-6 pad0 column-left">
											<h2>{{vacancy.name}}</h2>
											<p class="large-text last">{{vacancy.description1}}</p>
										</div>
										<div class="col-6 pad0 column-right">
											<p class="large-text last">{{vacancy.description2}}</p>
										</div>
									</div>
								</div>
								<div class="center-panel bg-black">
									<div class="row mrg0">
										<div class="col-6 pad0 column-left">
											<div class="row">
												<div class="col-7">
													<h4>Locatie</h4>
													<strong class="title-1">{{vacancy.location}}</strong>
												</div>
												<div class="col-5">
													<h4>Rel. Ervaring</h4>
													<strong class="title-1">{{vacancy.experience}}+ Jaar</strong>
												</div>
											</div>
										</div>
										<div class="col-6 pad0 column-right text-right">
											<a href="#formpage" class="primarybtn">Solliciteer</a>
										</div>
									</div>
								</div>
								<div class="bottom-panel">
									<div class="row mrg0">
										<div class="col-6 pad0 bg-gray column-left">
											<h3>Jouw Skills</h3>
											<ul class="listitems smalllist">
                                                <li :key="item" v-for="item in vacancy.requirements">{{item}}</li>
											</ul>
										</div>
										<div class="col-6 pad0 bg-dark-gray column-right">
											<h3>Wij Bieden</h3>
											<ul class="listitems smalllist">
                                                <li :key="item" v-for="item in vacancy.offers">{{item}}</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- end banner -->
		
			<!-- start megapanel-bar -->
			<div class="megapanel-bar maincontact-bar secondary" id="formpage">
				<div class="container">
					<div class="row">
						<div class="col-12">
							<div class="inner">
								<div class="row mrg0">
									<div class="col-6 pad0">
										<figure class="figure-1"></figure>
									</div>
									<div class="col-6 pad0">
										<form :action="this.$mirzacles.applyEndPoint" @submit="submitApplyForm" method="POST" class="megaform">
											<div class="row">
												<div class="col-12">
													<h2>Apply here</h2>
												</div>
											</div>
											<div class="row">
												<div class="input-group col-12">
													<span class="invalid-feedback"></span>
													<input type="text" class="inputtext" name="name" placeholder="Naam*">
												</div>
											</div>
											<div class="row">
												<div class="input-group col-6">
													<span class="invalid-feedback"></span>
													<input type="text" class="inputtext" name="phone" placeholder="Telefoonnummer">
												</div>
												<div class="input-group col-6">
													<span class="invalid-feedback"></span>
													<input type="text" class="inputtext" name="email" placeholder="E-Mailadres*">
												</div>
											</div>
											<div class="row">
												<div class="input-group col-12">
													<span class="invalid-feedback"></span>
													<textarea type="text" class="inputtext" name="message" placeholder="Motivatie*"></textarea>
												</div>
											</div>
											<div class="row">
												<div class="input-group col-12">
													<span class="invalid-feedback"></span>
													<div class="cstmselectfile">
														<input id="cv_input" type="text" class="inputtext" placeholder="CV Uploaden*" value="" readonly>
														<div>
															<input type="file" name="cv" @change="displayFileName"/><span class="btn">Selecteer Bestanden</span>
														</div>
													</div>
												</div>
											</div>
											<div class="row">
												<div class="col-12">
													<div class="bg-black">
														<button type="submit" id="send-btn" class="primarybtn">
															<div class="loader-container">
																<div class="typing_loader"></div>
															</div>
															Sollicitatie Versturen
														</button>
													</div>
												</div>
											</div>
										</form>

										<div id="success">
											<div class="row">
												<div class="col-12">
													<h2>Gedaan!</h2>
													<p>Bedankt voor het indienen van je CV. We zullen hem doornemen en komen er binnen 2 werkdagen op terug!</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- ends megapanel-bar -->

		</div>
		<!-- end content -->
    </div>
</template>

<style scoped>
.figure-1 {
    background: url('../assets/images/img-7.png') no-repeat center right/cover;
}

#success {
	padding: 32px;
    background: #fcc530;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
	right: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	transform: translateY(100%);
	transition: transform .4s ease;
}
#success.show {
	transform: translateY(0);
}

.loader-container {
	position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
	align-items: center;
	transform: scale(1.7);
	opacity: 0;
	transition: all .3s ease;
}
.typing_loader {
    width: 6px;
    height: 6px;
    border-radius: 50%;
	animation: typing 1s linear infinite alternate;
    position: relative;
    left: -12px;
}
#send-btn.busy{
	position: relative;
	color: #161616;
}
#send-btn.busy::after {
	margin-left: 16px;
	opacity: 0;
}

#send-btn.busy .loader-container {
	transform: scale(1.7);
	opacity: 1;
}

@keyframes typing{
   	0%{
        background-color: rgba(255,255,255, 1);
        box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                    24px 0px 0px 0px rgba(255,255,255,0.2);
	}
    25%{ 
        background-color: rgba(255,255,255, 0.4);
        box-shadow: 12px 0px 0px 0px rgba(255,255,255,2), 
                    24px 0px 0px 0px rgba(255,255,255,0.2);
    }
    75%{ background-color: rgba(255,255,255, 0.4);
        box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                    24px 0px 0px 0px rgba(255,255,255,1);
	}
}
</style>

<script>
import axios from 'axios';

export default {
    name: 'Vacancy',
    data() {
        return {
            vacancy: null
        }
    },
    beforeMount() {
        const slug = this.$route.params.vacancy;
        for (const vac in this.$mirzacles.vacancies) {
            if (this.$mirzacles.vacancies.hasOwnProperty(vac)) {
                const element = this.$mirzacles.vacancies[vac];
                if (element.slug == slug) {
                    this.vacancy = element;
                    break;
                }
            }
        }
	},
	methods: {// get all data in form and return object
        getFormData(form) {
			const elements = form.elements;
            let honeypot;

            const fields = Object.keys(elements).filter(function(k) {
                if (elements[k].name === "honeypot") {
                    honeypot = elements[k].value;
                    return false;
                }
                return true;
            }).map(function(k) {
                if(elements[k].name !== undefined) {
                    return elements[k].name;
                // special case for Edge's html collection
                }else if(elements[k].length > 0){
                    return elements[k].item(0).name;
                }
            }).filter(function(item, pos, self) {
                return self.indexOf(item) == pos && item;
            });

			
			return new Promise((res, rej) => {
				let formData = {};

				// add form-specific values into the data
				formData.formDataNameOrder = JSON.stringify(fields);

				fields.forEach(function(name){
					const element = elements[name];
					
					// singular form elements just have one value
					formData[name] = element.value;

					// when our element has multiple items, get their values
					if (element.length && element.type !== 'file') {
						let data = [];
						for (let i = 0; i < element.length; i++) {
							let item = element.item(i);
							if (item.checked || item.selected) {
								data.push(item.value);
							}
						}
						formData[name] = data.join(', ');
					}

					if (element.type == 'file' && element.files[0]) {
						let reader = new FileReader();
						const file = element.files[0];
						
						reader.onloadend = e => {
							const rawData = e.target.result.split(",");
							const obj = {fileName: file.name, mimeType: rawData[0].match(/:(\w.+);/)[1], data: rawData[1]};
							formData[name] = obj;
							res({data: formData, honeypot: honeypot});
						};

						reader.readAsDataURL(file);
					}

				});
			});

        },
        submitApplyForm(e) {
			e.preventDefault();
			
			const requiredFields = ['name', 'email', 'message', 'cv'];

			requiredFields.forEach(field => {
				const input = field == 'cv' ? document.querySelector(`#cv_input`) : document.querySelector(`[name="${field}"]`);
				input.classList.remove('is-invalid');
				input.closest('.input-group').querySelector('.invalid-feedback').classList.add('d-none');
			});

			let emptyFields = [];
			
			requiredFields.forEach(field => {
				const input = document.querySelector(`[name="${field}"]`);
				if (!input.value || (input.type == 'file' && !input.files.length)) {
					emptyFields.push(field);
				}
			});

			if (emptyFields.length) {
				emptyFields.forEach(field => {
					const input = field == 'cv' ? document.querySelector(`#cv_input`) : document.querySelector(`[name="${field}"]`);
					input.classList.add('is-invalid');
					const warning = input.closest('.input-group').querySelector('.invalid-feedback');
					warning.classList.remove('d-none');
					warning.innerText = 'Dit veld is verplicht';
				});
				
				return;
			}

			document.querySelector('#send-btn').disabled = true;
			document.querySelector('#send-btn').classList.add('busy');

			this.getFormData(e.target).then((formData) => {
				
				let data = formData.data;

				// If a honeypot field is filled, assume it was done so by a spam bot.
				if (formData.honeypot) {
					return false;
				}
				
				axios.post(e.target.action, data, {
					headers: {
						"Content-Type": "application/x-www-form-urlencoded"
					}
				})
					.then(res => {
						console.log(res)
						if (res.data.result == "success") {
							document.querySelector('#success').classList.add('show');
						}
					})
					.catch(err => console.error(err));
			});

		},
		displayFileName(e) {
			const file = e.target.files[0].name;
			document.querySelector("#cv_input").placeholder = file;
		}
    },
}


</script>